





import React, { useState, useRef } from "react";
import "../../Users/components/modules/promotions/Promotions.css";
import CreateCampaign from '../components/modules/promotions/CreateCampaign.jsx';
import Promotiondashbord from '../components/modules/promotions/Promotiondashbord';
import Campaignanlytics from '../components/modules/promotions/Campaignanlytics';
import Overview from "../components/modules/promotions/Overview.jsx";
import PromotionPricingSection from "../components/modules/promotions/PromotionPricingSection.jsx";
// import Campainoffers from "./Campainoffers.jsx";
import CampaignManager from "../components/modules/promotions/CampaignManager.jsx";
import LeadGeneration from "../components/modules/promotions/LeadGeneration.jsx";
import CampaignsDetails from "../components/modules/promotions/CampaignsDetails.jsx"
/* ---------- Main Company Component ---------- */
const DummySection = ({ title }) => (

    <div className="dummy-section">
        <h2>{title}</h2>
        <p>This is a placeholder for the {title} section.</p>
    </div>
);

const Promotions = () => {
    const containerRef = useRef(null);
    const [activeTab, setActiveTab] = useState(5); // Default to OVERVIEW (id: 5)

    const scrollToTop = () => {
        containerRef.current?.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    // Navigation function to switch tabs by name
    const navigateToTab = (tabName) => {
        const tab = tabs.find(t => t.name === tabName);
        if (tab) {
            setActiveTab(tab.id);
            scrollToTop();
        }
    };
    const goToPricing = () => {
        setActiveTab(6); // Pricing Tab ID
    };
    const tabs = [
        {
            id: 5,
            name: "OVERVIEW",
            component: () => (
                <Overview
                    title="Campaign Overview"
                    onNavigate={navigateToTab}
                />
            ),
        },
        {
            id: 6,
            name: "PRICING",
            component: () => <PromotionPricingSection title="Campaign Pricing" />,
        },
        {
            id: 2,
            name: "CREATE CAMPAIGN",
            component: () => <CreateCampaign title="Create New Campaign" scrollToTop={scrollToTop} />,
        },
        // {
        //     id: 1,
        //     name: "CAMPAIGNS",
        //     component: () => <Promotiondashbord title="All Campaigns" onNavigate={navigateToTab} />,
        // },
        {
            id: 1,
            name: "ANALYTICS",
            component: () => <CampaignsDetails title="All Campaigns" onNavigate={navigateToTab} />,
        },
        // { 
        //     id: 8, 
        //     name: "Leads",
        //     component: () => (
        //         <LeadGeneration
        //             title="All Campaigns"
        //             onNavigate={navigateToTab}
        //         />
        //     ),
        // },


        // {
        //     id: 3,
        //     name: "Offers",
        //     component: () => <Campainoffers title="Admin Approval Panel" />,
        // },
        // {
        //     id: 7,
        //     name: "Notifaction",
        //     component: () => <CampaignManager title="Admin Approval Panel" />,
        // },
        // {
        //     id: 4,
        //     name: "ANALYTICS",
        //     component: () => <Campaignanlytics title="Campaign Analytics" />,
        // },
    ];

    const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component;

    return (
        <div className="company-container" ref={containerRef}>
            {/* 🔹 Inline CSS */}
            <style>{`
                /* Default (Mobile first) – kuch change nahi */
                .company-scroll-container {
                    position: static;
                    background: #fff;
                }
                
                .company-buttons-row {
                    display: flex;
                    flex-wrap: wrap;
                }
                
                .company-button {
                    padding: 8px 16px;
                    border: none;
                    background: #f0f0f0;
                    cursor: pointer;
                    border-radius: 6px;
                    white-space: nowrap;
                }
                
    
                
                /* ✅ Desktop / Laptop only */
                @media (min-width: 769px) {
                    .company-scroll-container {
                        position: sticky;
                        top: 0;
                        z-index:10;
                     
                    }
                }
                @media (max-width: 769px) {
                     .company-buttons-row { 
                        flex-wrap: nowrap;
                        width:80vw;
                        overflow:auto;
                        scrollbar-width:none;
                    }
                }
            `}</style>

            {/* Tabs */}
            <div className="company-scroll-container">
                <div className="company-buttons-row">
                    {tabs.map(tab => (
                        <button
                            key={tab.id}
                            className={`company-button ${activeTab === tab.id ? "active" : ""}`}
                            onClick={() => setActiveTab(tab.id)}
                        >
                            {tab.name}
                        </button>
                    ))}
                </div>
            </div>

            {/* Active Section */}
            <div className="component-display">
                {ActiveComponent && <ActiveComponent />}
            </div>
        </div>
    );
};

export default Promotions;